import {
  FluentProvider,
  InputOnChangeData,
  PartialTheme,
  SearchBox,
  SearchBoxChangeEvent,
  SearchBoxProps,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";


interface SearchBoxCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
  onChangeText?: (event: SearchBoxChangeEvent, newValue?: string) => void;
}

const SearchBoxCustom = (props: SearchBoxCustomProps & SearchBoxProps) => {
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  const onChange = (event: SearchBoxChangeEvent, data: InputOnChangeData) => {
    if (props.onChangeText) {
      props.onChangeText(event, data.value);
    }
  };
  return props.theme ? (
    <FluentProvider
      theme={
        props.theme === "dark"
          ? webDarkTheme
          : {
              ...renderTheme,
              colorCompoundBrandStroke: "rgb(70, 101, 136)",
              colorCompoundBrandStrokeHover: "rgb(21, 51, 89)",
              colorCompoundBrandForeground1: "rgb(70, 101, 136)",
            }
      }
    >
      <SearchBox {...props} onChange={onChange} />
    </FluentProvider>
  ) : (
    <SearchBox {...props} />
  );
};

export default SearchBoxCustom;
